import type { GridColDef } from '@mui/x-data-grid';
import type { UnchargedUsageReport } from '@weft/types';
import { dayjs, type ItemOf, type ValueOf } from '@weft/utils';
import { formatDate } from 'apps/app/src/utils/date';
import { VyTableCell } from '../../../../../components/new-design/table/vy-table/VyTableCell';

export const UNCHARGED_USAGE_REPORT_KEYS = Object.freeze({
  CUSTOMER_NAME: 'customerName',
  METER_NAME: 'meterName',
  PERIOD: 'period',
  REASON: 'reason',
  VALUE: 'value',
} satisfies Record<string, keyof ItemOf<UnchargedUsageReport>>);

export type UnchargedUsageReportColumnKeys = ValueOf<typeof UNCHARGED_USAGE_REPORT_KEYS>;

export const UNCHARGED_USAGE_REPORT_COLUMNS: GridColDef<ItemOf<UnchargedUsageReport>>[] = [
  {
    field: UNCHARGED_USAGE_REPORT_KEYS.CUSTOMER_NAME,
    headerName: 'Customer',
    headerClassName: 'text-sm',
    flex: 1,
    valueGetter: (params) => params.row.customerName,
    headerAlign: 'left',
    align: 'center',
    renderCell: ({ row: { customerName } }) => (
      <VyTableCell
        value={customerName}
        containerClassName='justify-start'
      />
    ),
  },
  {
    field: UNCHARGED_USAGE_REPORT_KEYS.PERIOD,
    headerName: 'Date',
    headerClassName: 'text-sm',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: ({ value }) => dayjs(value.startTime).format('YYYY-MM-DD'),
    renderCell: ({ row: { period } }) => <VyTableCell value={formatDate(period.startTime)}/>,
  },
  {
    field: UNCHARGED_USAGE_REPORT_KEYS.METER_NAME,
    headerName: 'Product',
    headerClassName: 'text-sm',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ value }) => <VyTableCell value={value}/>,
  },
  {
    field: UNCHARGED_USAGE_REPORT_KEYS.REASON,
    headerName: 'Reason',
    headerClassName: 'text-sm',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row: { reason } }) => <VyTableCell value={reason}/>,
  },
  {
    field: UNCHARGED_USAGE_REPORT_KEYS.VALUE,
    headerName: 'Value',
    headerClassName: 'text-sm',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row: { value } }) => <VyTableCell value={value}/>,
  },
];
